import { r as registerInstance, c as createEvent, h } from './index-4df07f2a.js';
import { r as get_1 } from './get-f8984301.js';

const IconClose = `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z" fill="currentColor"/>
</svg>
`;

const scmpMenuMainMenuCss = ".scmp-menu-main-menu__outside-area{position:absolute;width:100%;height:100%;top:0;left:0}.scmp-menu-main-menu__content{display:block;background-color:#222834}.scmp-menu-main-menu__content--desktop{padding:24px 28px 120px}.scmp-menu-main-menu__content--mobile{padding:18px 24px 120px}.scmp-menu-main-menu__mobile-header{margin-top:-16px;margin-left:-6px;margin-right:-6px;padding-top:16px;padding-bottom:16px;border:1px solid rgba(255,255,255,0.6);border-width:0 0 1px;margin-bottom:24px;position:sticky;top:0;background-color:#222834;z-index:10}.scmp-menu-main-menu__close{cursor:pointer;color:rgba(255,255,255,0.6);width:20px;height:20px;display:inline-block;position:absolute;top:0;right:0}.scmp-menu-main-menu__non-sub{opacity:0;transition:opacity .2s ease-in-out}.scmp-menu-main-menu__non-sub--show{opacity:1}.scmp-menu-main-menu__non-sub-panel{position:relative}.scmp-menu-main-menu__non-sub-panel--desktop{border:1px solid rgba(161,161,161,0.3);border-width:0 0 1px;padding-bottom:24px}.scmp-menu-main-menu__non-sub-panel--mobile{display:flex;align-items:center;padding-bottom:32px;min-height:41px}.scmp-menu-main-menu__non-sub-panel--padded{padding-bottom:32px}.scmp-menu-main-menu__highlights{padding-top:4px;padding-bottom:4px;border:1px solid rgba(161,161,161,0.3);border-width:1px 0;margin-bottom:32px}.scmp-menu-main-menu__tab-section{display:block}.scmp-menu-main-menu__search{position:absolute;right:0}.scmp-menu-main-menu__search--expand{width:100%}.scmp-menu-main-menu__top-tab{padding-bottom:8px}";

let ScmpMenuMainMenu = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closeClicked = createEvent(this, "closeClicked", 7);
    this.isSearchOpened = true;
    this.closeClickHandler = () => {
      this.closeClicked.emit();
    };
  }
  get theme() {
    return get_1(this.menuConfig, 'theme');
  }
  get queryString() {
    return get_1(this.menuConfig, 'queryString');
  }
  get isShowSubscription() {
    return get_1(this.menuConfig, 'showSubscriptionInstruction');
  }
  get isShowBookmarkAlert() {
    return get_1(this.menuConfig, 'isShowBookmarkAlert');
  }
  get isShowSubscriptionInstruction() {
    switch (this.theme) {
      case 'mobile': {
        if (this.isShowSubscription) {
          return this.isSearchOpened;
        }
        return false;
      }
      case 'desktop': {
        return this.isSearchOpened;
      }
    }
    return null;
  }
  get toolbarContent() {
    switch (this.theme) {
      case 'mobile': {
        return (h("div", { class: "scmp-menu-main-menu__mobile-header" }, h("scmp-menu-mobile-header", { isShowBookmarkAlert: this.isShowBookmarkAlert, edition: this.menuConfig.edition, editionList: this.editionList })));
      }
    }
    return null;
  }
  get headerContent() {
    switch (this.theme) {
      case 'mobile': {
        return (h("div", null, h("div", { class: "scmp-menu-main-menu__non-sub-panel scmp-menu-main-menu__non-sub-panel--mobile" }, this.isShowSubscription && (h("div", { class: {
            'scmp-menu-main-menu__non-sub': true,
            'scmp-menu-main-menu__non-sub--show': this.isShowSubscriptionInstruction,
          } }, h("scmp-menu-non-subscriber-instruction", null))), h("div", { class: {
            'scmp-menu-main-menu__search': true,
            'scmp-menu-main-menu__search--expand': !this.isShowSubscriptionInstruction,
          } }, h("scmp-menu-search-area", { defaultExpand: !this.isShowSubscription, onSearchOpenClicked: () => { this.isSearchOpened = false; } })))));
      }
      case 'desktop': {
        return (h("div", null, h("div", { class: {
            'scmp-menu-main-menu__non-sub-panel': true,
            'scmp-menu-main-menu__non-sub-panel--desktop': true,
            'scmp-menu-main-menu__non-sub-panel--padded': !this.isShowSubscription,
          } }, h("span", { onClick: this.closeClickHandler, class: "scmp-menu-main-menu__close", innerHTML: IconClose }), this.isShowSubscription && (h("scmp-menu-non-subscriber-instruction", null)))));
      }
    }
    return null;
  }
  get topTabContent() {
    const menuItems = get_1(this.topTab, 'items', []);
    const theme = get_1(this.topTab, 'type');
    return (h("div", { class: `scmp-menu-main-menu__top-tab scmp-menu-main-menu__top-tab--${this.theme}` }, h("scmp-menu-list", { menuItems: menuItems, theme: theme, parent: menuItems[0], queryString: this.queryString })));
  }
  render() {
    return (h("div", { class: "scmp-menu-main-menu" }, h("div", { class: `scmp-menu-main-menu__content scmp-menu-main-menu__content--${this.theme}` }, this.toolbarContent, h("scmp-menu-switch-version-button", { showBackToV1Button: this.showBackToV1Button, edition: this.menuConfig.edition, showBackToV2Button: this.showBackToV2Button }), this.headerContent, this.topTabContent, h("div", { class: "scmp-menu-main-menu__tab-section" }, h("scmp-menu-tab-section", { tabs: this.tabs, queryString: this.queryString })))));
  }
};
ScmpMenuMainMenu.style = scmpMenuMainMenuCss;

const scmpMenuMainMenuPlaceholderCss = ".scmp-menu-main-menu-placeholder{width:100%;height:100vh;background-color:#222834;display:flex;justify-content:center;align-items:center}";

let ScmpMenuMainMenuPlaceholder = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "scmp-menu-main-menu-placeholder" }, h("img", { src: "https://assets.i-scmp.com/static/img/gifs/wheel_on_white.gif", alt: "loading", width: "122", height: "122" })));
  }
};
ScmpMenuMainMenuPlaceholder.style = scmpMenuMainMenuPlaceholderCss;

export { ScmpMenuMainMenu as scmp_menu_main_menu, ScmpMenuMainMenuPlaceholder as scmp_menu_main_menu_placeholder };
